import React, { useEffect, useLayoutEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router';
import LayoutNoSidebar from "../layout/Index-nosidebar";
import Login from '../pages/auth/Login';
import MainSystemLoader from '../pages/loaders/MainSystemLoader';
import * as app_consts from "../utils/app_consts";
import { getFirstPathAfterCom, getTenantURLPrefix } from '../utils/Utils';

// Load First 
const currentUrl = window.location.href;
const home_tenant_url_prefix = getFirstPathAfterCom(currentUrl);

const SystemLoaders = ({ type }) => {
 const navigate = useNavigate();
 const location = useLocation();


 useLayoutEffect(() => {
  window.scrollTo(0, 0);
 }, [location]);

 useEffect(() => {
  navigate(`/${home_tenant_url_prefix}`);
 }, []);

 return (
  <>
   <Routes>
    <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
     <Route path={`/:tenant_url_prefix`} element={<MainSystemLoader />} />
     <Route path="*" element={<Navigate to={`/${home_tenant_url_prefix}`} replace />} />
     <Route path="/" element={<Navigate to={`/${home_tenant_url_prefix}`} replace />} />
    </Route>
   </Routes>
  </>
 );
};

export default SystemLoaders;